var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-26 mb-24"},[_c('img',{attrs:{"src":_vm.dataset.image}}),_c('p',{staticClass:"h1"},[_c('b',[_vm._v(_vm._s(_vm.dataset.headline))])]),_c('p',{staticClass:"mb-24"},[_c('b',[_vm._v(_vm._s(_vm.dataset.subline))])]),_c(_vm.dataset.questions.type,{tag:"component",attrs:{"dataset":_vm.dataset.questions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }